/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class SystemLevelService extends services.DataService<Wars.Domain.Model.SystemLevel> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public getSystemLevel() {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels");

            return this.fetch(query);
        }

        public getMostSystemLevelInfo(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevelsLazy")
                .expand("variableSchema, myConstants, myClaims, myEmailGroups, myStaticDocuments, myCalculations.valueOperation, myTimeTrackers, myClaimGroups");

            return this.fetch(query);
        }

        public getSystemLevelConstants(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myConstants");

            return this.fetch(query);
        }

        public getSystemLevelJsonDictionaryStores(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myJsonDictionaryStores");

            return this.fetch(query);
        }

        public getSystemLevelMapConfigurations(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myMapConfigurations.layers, myMapConfigurations.defaultLayer");

            return this.fetch(query);
        }

        public getSystemLevelObjectQueries(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myObjectQueries.myProjectionObjectSchema.properties.typeSchema.properties, myObjectQueries.myInputObjectSchema.properties");

            return this.fetch(query);
        }

        public getSystemLevelSecurityMatrices(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("mySecurityMatrices.claimBindings");

            return this.fetch(query);
        }

        public getSystemLevelVariables(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("variableSchema.properties");

            return this.fetch(query);
        }

        public getSystemLevelClaims(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myClaims");

            return this.fetch(query);
        }

        public getSystemLevelClaimsWithGrantAuthorizations(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            var expand = "myClaims.claimGrantAuthorities.myGrantClaimDefinition, " +
                "myClaims.claimGrantAuthorities.claimGrantAuthorityValues, " +
                "myClaims.claimGrantAuthorities.claimGrantRestrictionValues";

            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand(expand);

            return this.fetch(query);
        }

        public getUserRepositoryConfigurations(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myUserRepositoryConfigurations");

            return this.fetch(query);
        } 

        public getSystemLevelEmailGroups(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myEmailGroups.myEmailAddresses, myEmailGroups");

            return this.fetch(query);
        }

        public getSystemEmailConfigurations(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            var expand = "myEmailConfigurations, " +
                "myEmailConfigurations.recipients.claim, " +
                "myEmailConfigurations.carbonCopies, " +
                "myEmailConfigurations.blindCarbonCopies, " +
                "myEmailConfigurations.documents";

            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand(expand);

            return this.fetch(query);
        }

        public getSystemLevelBatchJobs(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand('myBatchJobConfigurations, myBatchJobConfigurations.parameters, myBatchJobConfigurations.parameters.treeItem');

            return this.fetch(query);
        }

      public getSystemLevelApiConfigurations(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
        const query = this.breezeModule.EntityQuery
          .from("SystemLevels")
          .expand('myApiConfigurations.parameters');

        return this.fetch(query);
      }

        public getSystemLevelStaticDocuments(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myStaticDocuments");

            return this.fetch(query);
        }

        public getSystemLevelCalculations(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myCalculations");

            return this.fetch(query);
        }

        public getSystemLevelPaymentInfo(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            var expand = "myPaymentConfigurations.myCustomActionInputs.myTreeItem, " +
                "myPaymentConfigurations.myPaymentRequestFormValueLookup.myTreeItem, " +
                "myPaymentConfigurations.myPaymentCustomInformation.valueCalculation, " +
                "myPaymentConfigurations.myMappings.treeItem, " +
                "myPaymentConfigurations.myMappings.customInfo, " +
                "myPaymentConfigurations.amountTreeItem";

            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand(expand);

            return this.fetch(query);
        }

        public getSystemLevelQueryConfigurations(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            var expand = "myQueryConfigurations.parameters.treeItem, " +
                "myQueryConfigurations.myDataOperation.resultSchema.properties, " +
                "myQueryConfigurations.myDataOperation.myDataSource.objectSchemas.properties";

            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand(expand);

            return this.fetch(query);
        }

        public getSystemLevelCodes(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myCodeGroups.codes");

            return this.fetch(query);
        }

        public getSystemLevelDocumentConfiguration(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            var expand =
                "systemDocumentConfiguration.documentTypeCodeGroup.codes, " +
                "myDocumentConfigurations.canDownloadSecureDocumentSecurityMatrix, " +
                "myDocumentConfigurations.canSecureDocumentSecurityMatrix, " +
                "myDocumentConfigurations.myAvailableDocumentTypes.mySystemCode";
             
            const query = this.breezeModule.EntityQuery
                .from("SystemLevelsLazy")
                .expand(expand);

            return this.fetch(query);
        }

        public getSystemLevelStatusesAndStates(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("statusCodeGroup.myStatuses.myStates");

            return this.fetch(query);
        }

        public getSystemLevelClaimGroups(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myClaimGroups");

            return this.fetch(query);
        }

        public getSystemLevelReviewGroups(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myReviewGroups, myCodeGroups");

            return this.fetch(query);
        }

        public getSystemLevelSubTypeGroups(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("mySubTypeGroups");

            return this.fetch(query);
        }

        public getSystemLevelSystemActions(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("mySystemActions");

            return this.fetch(query);
        }

        public getSystemLevelFormContainerAssociations(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myFormContainerAssociations");

            return this.fetch(query);
        }

        public getSystemLevelTimeTrackers(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myTimeTrackers.myTimePeriods, myTimeTrackers.myClockStates, statusCodeGroup.myStatuses.myStates");

            return this.fetch(query);
        }

        public getSystemLevelProcessEvents(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand("myProcessEventConfigurations");

            return this.fetch(query);
        }

        public getSystemLevelProcessEventConfigurations(): angular.IPromise<Wars.Domain.Model.SystemLevel> {
            const expand = "myProcessEventConfigurations.myInitiateSecurityMatrix, " +
                "myProcessEventConfigurations.myViewSecurityMatrix, " +
                "myProcessEventConfigurations.mySystemAction, " +
                "myProcessEventConfigurations.documentConfiguration.canDownloadSecureDocumentSecurityMatrix, " +
                "myProcessEventConfigurations.documentConfiguration.canSecureDocumentSecurityMatrix, " +
                "myProcessEventConfigurations.documentConfiguration.myAvailableDocumentTypes.mySystemCode";

            const query = this.breezeModule.EntityQuery
                .from("SystemLevels")
                .expand(expand);

            return this.fetch(query);
        }
    }
}

warsApp.registerService('SystemLevelService', ['breeze', '$q']);